/**
 * API client for backend communication
 */

const API_BASE = "https://ai.mdarj.org";
const WS_BASE = "wss://ai.mdarj.org";

export const api = {
  baseUrl: API_BASE,
  wsUrl: WS_BASE,

  /**
   * Transcribe an uploaded audio file
   */
  async transcribeFile(file: File, language: string = "auto") {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("language", language);

    const response = await fetch(`${API_BASE}/api/transcribe`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Transcription failed: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Get WebSocket URL for real-time transcription
   */
  getWebSocketUrl(): string {
    return `${WS_BASE}/ws/transcribe`;
  },

  /**
   * Health check
   */
  async healthCheck(): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE}/health`);
      return response.ok;
    } catch {
      return false;
    }
  },

  /**
   * Get available companies
   */
  async getCompanies(): Promise<{
    companies: { id: number; name: string }[];
    active_company_id: number | null;
    multi_company: boolean;
  }> {
    const response = await fetch(`${API_BASE}/api/companies`);
    if (!response.ok) {
      throw new Error("Failed to fetch companies");
    }
    return response.json();
  },

  /**
   * Select active company
   */
  async selectCompany(companyId: number): Promise<{
    success: boolean;
    company?: { id: number; name: string };
    error?: string;
  }> {
    const response = await fetch(`${API_BASE}/api/select-company`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ company_id: companyId }),
    });
    if (!response.ok) {
      throw new Error("Failed to select company");
    }
    return response.json();
  },
};
